module.exports = __webpack_public_path__ + "img/qc.8b9a6d9e.png";